import React from 'react';
import { Helmet } from 'react-helmet';

const SeoHelmet = ({ 
  title = "HI-WAY 89 Entertainment | Bridging Canadian & African Music",
  description = "Good music needs no permission to cross borders. At Hi-Way 89 Entertainment, we bridge Canadian and African sounds with the world, spotlighting talent from everywhere and creating global hits.",
  canonical = "",
  ogImage = "/social-preview.jpg",
  ogType = "website",
  keywords = "Hi-Way 89, record label, Canadian music, African music, cross-cultural music, global hits, music distribution, artist development, music bridge, Canadian artists, African artists",
  structuredData = null
}) => {
  const siteUrl = "https://hiway89.com";
  const fullCanonical = canonical ? `${siteUrl}${canonical}` : siteUrl;
  const fullOgImage = `${siteUrl}${ogImage}`;

  // Default structured data for the organization
  const defaultStructuredData = {
    "@context": "https://schema.org",
    "@type": "MusicGroup",
    "name": "HI-WAY 89 Entertainment",
    "description": "Bridging Canadian and African sounds with the world. We work with artists who refuse to be boxed in, spotlighting talent from everywhere and turning them into global stars.",
    "url": siteUrl,
    "logo": `${siteUrl}/logo.png`,
    "foundingDate": "2025",
    "founder": [
      {
        "@type": "Person",
        "name": "Ikenna Nwagboso"
      },
      {
        "@type": "Person",
        "name": "Camillo Doregos"
      }
    ],
    "address": {
      "@type": "PostalAddress",
      "addressCountry": ["CA", "NG"],
      "addressLocality": ["Toronto, Canada", "Lagos, Nigeria"]
    },
    "areaServed": "Worldwide",
    "sameAs": [
      "https://www.instagram.com/hiway89ent?igsh=Zm42ZjRtYmoyN3l4",
      "https://x.com/hiway89ent?s=21&t=W37y8xb6JUNjJS1xSpoj4Q",
      "https://youtube.com/hiway89"
    ]
  };

  const finalStructuredData = structuredData || defaultStructuredData;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content="HI-WAY 89 Entertainment" />
      <meta name="robots" content="index, follow" />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={fullCanonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullOgImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content="HI-WAY 89 Entertainment" />
      <meta property="og:locale" content="en_CA" />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={fullCanonical} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={fullOgImage} />
      <meta property="twitter:site" content="@hiway89ent" />
      
      {/* Canonical URL */}
      <link rel="canonical" href={fullCanonical} />
      
      {/* Additional Meta Tags */}
      <meta name="geo.region" content="CA" />
      <meta name="geo.placename" content="Canada" />

      {/* Structured Data / JSON-LD */}
      <script type="application/ld+json">
        {JSON.stringify(finalStructuredData)}
      </script>
    </Helmet>
  );
};

export default SeoHelmet;